// extracted by mini-css-extract-plugin
export default {"active":"Button_active__2uerg","normal":"Button_normal__QcD-z"};